module.exports = __webpack_public_path__ + "img/structure03.3bf8fbc7.svg";